module.exports = __webpack_public_path__ + "img/feat-become-a-loyalty-expert.2e0dc7ce.svg";